import styled from 'styled-components';

type Props = {
  size: string;
  src?: string;
  radius?: string;
  border?: string;
};

type styledProps = {
  size: string;
  radius: string;
  border: string;
};

export const Avatar = ({
  size,
  src = '/images/icon.png',
  radius = '50%',
  border = 'none',
}: Props) => {
  return (
    <Wrapper size={size} radius={radius} border={border}>
      <Img src={src} />
    </Wrapper>
  );
};

const Wrapper = styled.div<styledProps>`
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  border-radius: ${(props) => props.radius};
  border: ${(props) => props.border};
  background-color: #ebebeb;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
